import { openRelatedSettings, pushRecent } from './relatedSettingsStore';
import { availableSettings, matches } from './relatedResolve';

/**
 * relatedPaletteSection — "הגדרות" in the Ctrl+K palette: every setting that matches the query
 * (only those whose screen is in the user's menu), plus "הגדרות קשורות למסך הזה" when the query is empty.
 */
export function relatedPaletteSection(screens, query, navigate) {
  const q = String(query || '').trim();
  if (!q) {
    return { title: 'הגדרות', items: [{ key: 'rs-open', label: 'הגדרות קשורות למסך הזה', icon: 'sliders', kbd: 'Ctrl+,', onSelect: openRelatedSettings }] };
  }
  const items = availableSettings(screens)
    .filter((s) => matches(`${s.title} ${s.description || ''} ${s.keywords || ''} ${s.group || ''}`, q))
    .map((s) => ({
      key: `rs-${s.id}`,
      label: s.title,
      icon: s.icon || 'gear',
      sub: `הגדרה · ${s.group}`,
      onSelect: () => {
        pushRecent(s.id);
        navigate(`${s.path}${s.query ? `?${s.query}` : ''}`, { state: s.focus ? { relatedFocus: s.focus } : undefined });
      },
    }));
  return items.length ? { title: 'הגדרות', items: items.slice(0, 6) } : null;
}
